// @flow
import React from 'react';

export const ALinkWithInheritedColorAndUnderline = ({ href, children }) => (
  <a href={href} style={{ textDecoration: 'underline', color: 'inherit' }}>
    {children}
  </a>
);
